module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/static-page/page-list/page-list.component.css
// module id = ./src/app/static-page/page-list/page-list.component.css
// module chunks = main